import L_HTML5 from "../../assets/img/skills/html-5.svg";
import L_CSS3 from "../../assets/img/skills/css3.svg";
import L_SASS from "../../assets/img/skills/sass-1.svg";
import L_BOOTSTRAP from "../../assets/img/skills/bootstrap-4.svg";
import L_REACT from "../../assets/img/skills/react.svg";
import L_REDUX from "../../assets/img/skills/redux.svg";
import L_MATERIALUI from "../../assets/img/skills/material-ui-1.svg";
import L_REACT_BOOTSTRAP from "../../assets/img/skills/react-bootstrap.svg";
import L_GIT from "../../assets/img/skills/git-icon.svg";
import L_GITHUB_PAGES from "../../assets/img/skills/github.svg";
import L_GITHUB_API from "../../assets/img/skills/github-api.svg";
import L_JAVASCRIPT from "../../assets/img/skills/javascript.svg";
import L_NETLIFY from "../../assets/img/skills/netlify-icon.svg"
import L_POSTGRES from "../../assets/img/skills/postgresql.svg"
import L_MYSQL from "../../assets/img/skills/mssql.svg"
import L_VERCEL from "../../assets/img/skills/logo-vercel.svg"
import L_TAILWIND from "../../assets/img/skills/tailwindcss-icon.svg"
import L_AWS from "../../assets/img/skills/aws.svg"
import L_EXPRESS from "../../assets/img/skills/express.svg"
import L_NODE from "../../assets/img/skills/nodejs.svg"
import L_PYTHON from "../../assets/img/skills/python.svg"
import L_PYTHONANYWHERE from "../../assets/img/skills/pythonanywhere.svg"
import L_STYLED_COMPONENTS from "../../assets/img/skills/styled-components.svg"
import L_TYPESCRIPT from "../../assets/img/skills/typescript.svg"
import L_WORDPRESS from "../../assets/img/skills/wordpress-icon.svg"



export const skills = {
    frontend: [
      {
        link: "https://en.wikipedia.org/wiki/HTML5",
        imgAltText: "HTML 5",
        imgSrc: L_HTML5,
        skillName: "HTML5",
      },
      {
        link: "https://medium.com/beginners-guide-to-mobile-web-development/whats-new-in-css-3-dcd7fa6122e1",
        imgAltText: "CSS 3",
        imgSrc: L_CSS3,
        skillName: "CSS3",
      },
      {
        link: "https://www.javascript.com/",
        imgAltText: "JavaScript",
        imgSrc: L_JAVASCRIPT,
        skillName: "JavaScript",
      },
      {
        link: "https://sass-lang.com/",
        imgAltText: "Sass",
        imgSrc: L_SASS,
        skillName: "Sass",
      },
      {
        link: "https://reactjs.org/",
        imgAltText: "React JS",
        imgSrc: L_REACT,
        skillName: "React JS",
      },
      {
        link: "https://redux.js.org/",
        imgAltText: "Redux",
        imgSrc: L_REDUX,
        skillName: "Redux",
      },
      {
        link: "https://www.typescriptlang.org/",
        imgAltText: "TypeScript",
        imgSrc: L_TYPESCRIPT,
        skillName: "TypeScript",
      },
      {
        link: "https://www.python.org/",
        imgAltText: "Python",
        imgSrc: L_PYTHON,
        skillName: "Python",
      },
      
    ],
    frameworks:[
        {
            link: "https://material-ui.com/",
            imgAltText: "Material-UI",
            imgSrc: L_MATERIALUI,
            skillName: "Material-UI",
          },
          {
            link: "https://react-bootstrap.github.io/",
            imgAltText: "React Bootstrap",
            imgSrc: L_REACT_BOOTSTRAP,
            skillName: "React Bootstrap",
          },
          {
            link: "https://getbootstrap.com/",
            imgAltText: "Bootstrap",
            imgSrc: L_BOOTSTRAP,
            skillName: "Bootstrap",
          },
          {
            link: "https://tailwindcss.com/",
            imgAltText: "tailwindcss",
            imgSrc: L_TAILWIND,
            skillName: "Tailwind CSS",
          },
          {
            link: "https://expressjs.com/",
            imgAltText: "Express.js",
            imgSrc: L_EXPRESS,
            skillName: "Express.js",
          },
          {
            link: "https://nodejs.org/",
            imgAltText: "Node.js",
            imgSrc: L_NODE,
            skillName: "Node.js",
          },
          {
            link: "https://styled-components.com/",
            imgAltText: "Styled Components",
            imgSrc: L_STYLED_COMPONENTS,
            skillName: "Styled Components",
          },
          {
            link: "https://wordpress.org/",
            imgAltText: "WordPress",
            imgSrc: L_WORDPRESS,
            skillName: "WordPress",
          },
          
    ],

    hostingPlatforms: [
      {
        link: "https://aws.amazon.com/",
        imgAltText: "Amazon Web Services",
        imgSrc: L_AWS,
        skillName: "AWS",
      },
      {
        link: "https://www.netlify.com/",
        imgAltText: "Netlify",
        imgSrc: L_NETLIFY,
        skillName: "Netlify",
      },
      {
        link: "https://pages.github.com/",
        imgAltText: "GitHub Pages",
        imgSrc: L_GITHUB_PAGES,
        skillName: "GitHub Pages",
      },
      {
        link: "https://docs.github.com/en/rest",
        imgAltText: "GitHub REST API",
        imgSrc: L_GITHUB_API,
        skillName: "GitHub API",
      },
      {
        link: "https://vercel.com/",
        imgAltText: "Vercel",
        imgSrc: L_VERCEL,
        skillName: "Vercel",
      },
      {
        link: "https://www.pythonanywhere.com/",
        imgAltText: "PythonAnywhere",
        imgSrc: L_PYTHONANYWHERE,
        skillName: "PythonAnywhere",
      },
      // {
      //   link: "https://www.heroku.com/",
      //   imgAltText: "Heroku",
      //   imgSrc: L_HEROKU,
      //   skillName: "Heroku",
      // }
    ],
    databases: [
      {
        link: "https://www.postgresql.org/",
        imgAltText: "PostgresSQL Database",
        imgSrc: L_POSTGRES,
        skillName: "PostgreSQL Database",
      },
      {
        link: "https://www.mysql.com/",
        imgAltText: "MYSQL",
        imgSrc: L_MYSQL,
        skillName: "mySQL Database",
      },
    ],
    versionControl: [
      {
        link: "https://git-scm.com/",
        imgAltText: "GIT",
        imgSrc: L_GIT,
        skillName: "GIT",
      },
      {
        link: "https://github.com/",
        imgAltText: "GitHub",
        imgSrc: L_GITHUB_PAGES,
        skillName: "GitHub",
      },
    ],
  };